<template>
  <div class="secure-display-text">
    <span v-if="!showText">{{ hideText }}</span>
    <span v-else>{{ text }}</span>
    <el-button type="text" class="show-btn" size="mini" @click="toggleShowText">{{ showText ? '隐藏' : '展示' }}</el-button>
  </div>
</template>

<script>
import { phoneValidate } from '@/utils/validate'

export default {
  name: 'SecureDisplayText',
  props: {
    text: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      showText: false
    }
  },
  computed: {
    hideText() {
      if (phoneValidate(this.text)) {
        return this.text.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2')
      } else {
        return '******'
      }
    }
  },
  methods: {
    toggleShowText() {
      this.showText = !this.showText
    }
  }
}
</script>

<style lang="scss" scoped>
.secure-display-text {
  width: 100%;
  display: inline-block;
  vertical-align: middle;
  overflow: hidden;

  &:hover .show-btn {
    display: inline-block;
  }
}
.show-btn {
  display: none;
  float: right;
}
</style>
